import { useEffect } from 'react'
import { useSetAtom } from 'jotai'
import { UserService } from '@duck/api-definitions'
import { invitationDataAtom, assignmentTokenAtom } from '@/store/userAtoms'
import { useAuth } from '@/hooks/useAuth'
import { useTar } from '@/modules'
import { Button } from '@duck/ui'

interface InviteGateJoinPublicAssignmentProps {
  details: UserService.InvitationDetails
  token: string
}

export const InviteGateJoinPublicAssignment = ({ details, token }: InviteGateJoinPublicAssignmentProps) => {
  const { t } = useTar()
  const setInvitationData = useSetAtom(invitationDataAtom)
  const setAssignmentToken = useSetAtom(assignmentTokenAtom)
  const { joinPublicAssignment, isJoiningAssignment } = useAuth()

  useEffect(() => {
    setInvitationData(details)
    setAssignmentToken(token)
    return () => {
      setInvitationData(null)
      setAssignmentToken(null)
    }
  }, [details, token, setInvitationData, setAssignmentToken])

  return (
    <div className="w-full max-w-md space-y-4 text-center">
      <h1 className="text-2xl font-semibold">
        {t('invite.join.confirmTitle', { taskName: details.taskName ?? '' })}
      </h1>
      <p className="text-sm text-muted-foreground">
        {t('invite.join.confirmBody', { organizationName: details.organizationName ?? '' })}
      </p>
      <div className="flex gap-2 justify-center">
        <Button variant="outline" onClick={() => window.history.back()}>
          {t('invite.join.cancel')}
        </Button>
        <Button onClick={() => joinPublicAssignment()} disabled={isJoiningAssignment}>
          {t('invite.join.confirm')}
        </Button>
      </div>
    </div>
  )
}
